"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepeatLevels = void 0;
const lodash_1 = __importDefault(require("lodash"));
const DefaultColorTable = {
    "c1": [0, 5],
    "c2": [5, 10],
    "c3": [10, 15],
    "c4": [15, 20],
    "c5": [20, 25],
    "c6": [25, 30],
    "c7": [30, 35],
    "c8": [35, 40],
    "c9": [40, 50],
    "c10": [50, 60],
    "c11": [60, 70],
    "c12": [70, 80],
    "c13": [80, 90],
    "c14": [90, 100],
};
const getRepeatLevels = (resultDataList) => {
    if (lodash_1.default.isEmpty(resultDataList)) {
        return lodash_1.default.cloneDeep(DefaultColorTable);
    }
    let min = Number.MAX_VALUE;
    let max = 0;
    for (const nextCohort of resultDataList) {
        if (lodash_1.default.isEmpty(nextCohort)) {
            continue;
        }
        const cohortSize = nextCohort[0];
        if (cohortSize == 0) {
            continue;
        }
        for (let index = 0; index < nextCohort.length; index++) {
            if (nextCohort[index] == 0) {
                continue;
            }
            const percent = nextCohort[index] * 100.0 / cohortSize;
            min = Math.min(min, percent);
            max = Math.max(max, percent);
        }
    }
    const totalPercent = max - min;
    const step = totalPercent / 14;
    const colorMap = {};
    let previousTo = min + step;
    colorMap["c1"] = [0, previousTo];
    for (let index = 2; index < 14; index++) {
        const nextRange = [previousTo, previousTo + step];
        colorMap["c" + index] = nextRange;
        previousTo = nextRange[1];
    }
    colorMap["c14"] = [previousTo, 100];
    return colorMap;
};
exports.getRepeatLevels = getRepeatLevels;
